import type { AxiosInstance } from 'axios';

import type { TManualAnomalyCreateDto, TManualAnomalyResponseDto } from '../types';

export type TBatchManualAnomaliesRequestDto = {
  create: TManualAnomalyCreateDto[];
  update: TManualAnomalyCreateDto[];
  delete: string[];
};

export type TBatchManualAnomaliesResponseDto = {
  created: TManualAnomalyResponseDto[];
  updated: TManualAnomalyResponseDto[];
  deletedCount: number;
};

export class ManualAnomaliesApi {
  constructor(private readonly agent: AxiosInstance) {}

  fetchList(wellId: number, signal?: AbortSignal): Promise<TManualAnomalyResponseDto[]> {
    return this.agent
      .get<TManualAnomalyResponseDto[]>('/anomaly-registry/api/v1/anomalies/manual', {
        params: { wellId },
        signal,
      })
      .then((r) => r.data);
  }

  save(data: TBatchManualAnomaliesRequestDto, signal?: AbortSignal): Promise<TBatchManualAnomaliesResponseDto> {
    return this.agent
      .put<TBatchManualAnomaliesResponseDto>('/anomaly-registry/api/v1/anomalies/manual/batch', data, { signal })
      .then((r) => r.data);
  }
}
